import { useParams } from "react-router";
import { ConfirmationPositionsTable } from "@/services/backend/htz/confirmations/components/confirmation-positions-table";

export function PositionsRoute() {
  const { confirmationId } = useParams();

  return <ConfirmationPositionsTable confirmationId={confirmationId!} />;
}
